import { promisify } from "util"
import { stat } from "fs"

const statPromisified = promisify(stat)

export const fileStat = async (file) => {
  const stat = await statPromisified(file)
  return stat
}
